<template>
    <div>
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>
                        Print Outstanding Fee Receipt
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
             <v-btn v-if="learner_outstanding_data != null" class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <span v-if="learner_outstanding_data != null">
                <v-row dense justify="center">
                    <v-col cols="12" sm="6" md="6">
                        <v-card>
                            <v-simple-table dense class="elevation-1 table-container">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <td colspan="3">
                                                <center><strong>Outstanding Fees Receipt</strong></center>
                                            </td>
                                        </tr>
                                         <tr>
                                           <th v-if="org_basic_data.trust_logo">
                                                <center><img :src="org_basic_data.trust_logo" width="50%" alt="logo" /></center>
                                            </th>
                                            <td>
                                                <center>
                                                    <tr v-if="org_basic_data.trust_name">
                                                        <strong>{{org_basic_data.trust_name}}</strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.school_name">
                                                        <strong>{{org_basic_data.school_name}} </strong>
                                                    </tr>
                                                    <tr v-if="org_basic_data.address">
                                                        {{org_basic_data.address}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.phone">
                                                        Phone : {{org_basic_data.phone}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.email">
                                                        Email : {{org_basic_data.email}}
                                                    </tr>
                                                    <tr v-if="org_basic_data.website">
                                                        Website : {{org_basic_data.website}}
                                                    </tr>
                                                </center>
                                            </td>
                                            <th v-if="org_basic_data.school_logo">
                                                <center><img :src="org_basic_data.school_logo" width="50%" alt="logo" /></center>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                <center><strong>Student Details</strong></center>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">PRN No. :: {{learner_outstanding_data.registration_number}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">Student Name :: {{learner_outstanding_data.name}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">Standard :: {{learner_outstanding_data.standard}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3"> Receipt No. : {{learner_outstanding_data.receipt_no}} (Student Copy)</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">Date : {{learner_outstanding_data.receipt_date}}</td>
                                        </tr>
                                       <tr>
                                            <td colspan="2"><strong>Outstanding Fee</strong></td>
                                            <td><strong> Fees Amount (Rs.)</strong></td>
                                            <td><strong> Fine (Rs.)</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                            <td colspan="2">
                                                Outstanding Fee Paid For {{learner_outstanding_data.of_ay}}
                                            </td>
                                            <td>{{learner_outstanding_data.amount}}</td>
                                            <td>{{learner_outstanding_data.fine}}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Total Amount ::</strong> Rs. {{learner_outstanding_data.amount}}</td>
                                        </tr>
                                         <tr>
                                            <td colspan="3" class="text-left"><strong> Amount In Words ::</strong> {{ learner_outstanding_data.amount_in_words }} </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-left"><strong> Payment Mode::</strong> {{ learner_outstanding_data.payment_mode }} </td>
                                        </tr>
                                        <tr>
                                        <td colspan="3" class="text-right">
                                            <strong>Authorized Signature</strong>
                                        </td>
                                         </tr>
                                    </tbody>
                                     </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
                </span>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                learner_outstanding_data: null,
                radios: null,
                receipt_no: null,
                registration_no: null,
                ay: null,
                radios: null,
                org_basic_data:[],
            };
        },
        watch: {
            receipt_no() {
                this.getData();
            },

            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        created() {
            this.receipt_no = JSON.parse(this.$session.get("receipt_no"));
            this.ay = JSON.parse(this.$session.get("ay"));
            this.registration_no = JSON.parse(this.$session.get("registration_no"));
        },
        mounted() {
            this.getData();
        },
        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            convert(number) {
                var converter = require("number-to-words");
                const string = converter.toWords(number);
                const string1 = string.charAt(0).toUpperCase() + string.slice(1);
                return string1;
            },
            getData() {
                this.overlay = true;
                this.learner_outstanding_data = null;
                const formData = {
                    receipt_no: this.receipt_no,
                    registration_no: this.registration_no,
                    ay: this.ay,
                };
                axios
                    .post("/OutstandingFees/getStudentOutstandingFeeReceipt", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_outstanding_data = res.data.student_outstanding_details;
                            this.org_basic_data = res.data.org_basic_data
                            this.overlay = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        //close loader
                        this.overlay = false;
                    });
            },
        },
    };
</script>
<style scoped>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    @media print {
        header,footer,nav,date { 
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        body,
        tr,
        th,
        td {
            font-size: large !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        @page {
            margin-top: none;
            padding-top: none;
            size: 25.5in 15.5in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin: none;
            padding: none !important;
            font-size: large !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
    .table-container {
        overflow-x: hidden;
        overflow: hidden;
    }
</style>
